import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createModeOfTransport,
  getAllActiveModeOfTransport,
  getAllModeOfTransport,
  getModeOfTransportById,
  updateModeOfTransport,
} from "./services/modeOfTransport.services";
import { clearModeOfTransportDetails } from "./modeOfTransportSlice";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";

const CreateModeOfTransport: React.FC = () => {
  const formLoading = useAppSelector(
    (state) => state.modeOfTransport.formLoading
  );
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);
  const ModeOfTransportDetail = useAppSelector(
    (state) => state.modeOfTransport.ModeOfTransportDetail
  );
  const mode_of_transport_guid = useAppSelector(
    (state) => state.muidrawer.data
  );
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  useEffect(() => {
    return () => {
      dispatch(clearModeOfTransportDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (mode_of_transport_guid) {
      dispatch(getModeOfTransportById(mode_of_transport_guid));
    }
  }, [mode_of_transport_guid]);

  const handleSubmit = async (values: any) => {
    try {
      if (!mode_of_transport_guid) {
        const payload = {
          mode_of_transport: values.mode_of_transport,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createModeOfTransport(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearModeOfTransportDetails());
          isIndirect
            ? dispatch(getAllActiveModeOfTransport())
            : dispatch(getAllModeOfTransport());
        }
      } else {
        const payload = {
          mode_of_transport_guid: mode_of_transport_guid,
          mode_of_transport: values.mode_of_transport,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateModeOfTransport(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearModeOfTransportDetails());
          isIndirect
            ? dispatch(getAllActiveModeOfTransport())
            : dispatch(getAllModeOfTransport());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={ModeOfTransportDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {mode_of_transport_guid
                  ? "Update Mode Of Transport"
                  : "Add Mode Of Transport"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="mode_of_transport"
                label="Mode Of Transport"
                placeholder="Mode Of Transport"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "start",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={mode_of_transport_guid ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateModeOfTransport;
